import ArrowUpward from '@mui/icons-material/ArrowUpward';
import { CircularProgress, IconButton, useTheme } from '@mui/material';
import useMockLoading from '../../../../../../../../../../../components/Hooks/useMockLoading';
import { useChatMessagesContext } from '../../../../../../../contexts/chatMessages.context';
import ChatMessagePickMediaButton from './ChatMessagePickMediaButton';

interface SendMessageButtonProps {
  sendButtonDisabled: boolean;
}

const SendMessageButton = ({ sendButtonDisabled }: SendMessageButtonProps) => {
  const theme = useTheme();

  const { isSendingFirstMessageInChatWithoutId, submitFiles } = useChatMessagesContext();

  const { handleAsyncFunction: submitFilesWithLoading, isLoading: isUploadingFiles } =
    useMockLoading({ asyncFunction: submitFiles });

  if (isSendingFirstMessageInChatWithoutId) {
    return <CircularProgress size={26} />;
  }

  if (sendButtonDisabled || isUploadingFiles) {
    return (
      <ChatMessagePickMediaButton
        isUploading={isUploadingFiles}
        onPickMedia={submitFilesWithLoading}
      />
    );
  }

  return (
    <IconButton
      size="small"
      type="submit"
      style={{
        backgroundColor: theme.palette.primary.main,
      }}
    >
      <ArrowUpward style={{ color: 'white' }} fontSize="small" />
    </IconButton>
  );
};

export default SendMessageButton;
